/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import SelectInput from "./SelectInput";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class FontPicker extends Component {
	constructor(props) {
		super(props);
		let fonts = {
			Lato: [
				"Lato-Black",
				"Lato-Bold",
				"Lato-BoldItalic",
				"Lato-ExtraBold",
				"Lato-Italic",
				"Lato-Light",
				"Lato-Medium",
				"Lato-Regular",
				"Lato-SemiBold",
			],
			Lora: ["Lora-Bold", "Lora-BoldItalic", "Lora-Italic", "Lora-Regular"],
			Merriweather: [
				"Merriweather-Black",
				"Merriweather-Bold",
				"Merriweather-BoldItalic",
				"Merriweather-Italic",
				"Merriweather-Light",
				"Merriweather-Regular",
			],
			Montserrat: [
				"Montserrat-Black",
				"Montserrat-Bold",
				"Montserrat-BoldItalic",
				"Montserrat-ExtraBold",
				"Montserrat-Italic",
				"Montserrat-Light",
				"Montserrat-Medium",
				"Montserrat-Regular",
				"Montserrat-SemiBold",
			],
			"Open-Sans": [
				"OpenSans-Bold",
				"OpenSans-BoldItalic",
				"OpenSans-ExtraBold",
				"OpenSans-Italic",
				"OpenSans-Light",
				"OpenSans-Regular",
				"OpenSans-SemiBold",
			],
			Oswald: ["Oswald-Bold", "Oswald-Light", "Oswald-Medium", "Oswald-Regular", "Oswald-SemiBold"],
			Poppins: [
				"Poppins-Black",
				"Poppins-Bold",
				"Poppins-BoldItalic",
				"Poppins-ExtraBold",
				"Poppins-Italic",
				"Poppins-Light",
				"Poppins-Medium",
				"Poppins-Regular",
				"Poppins-SemiBold",
			],
			"PT-Serif": ["PTSerif-Bold", "PTSerif-BoldItalic", "PTSerif-Italic", "PTSerif-Regular"],
			Roboto: [
				"Roboto-Black",
				"Roboto-Bold",
				"Roboto-BoldItalic",
				"Roboto-Italic",
				"Roboto-Light",
				"Roboto-Medium",
				"Roboto-Regular",
			],
			"Source-Serif-Pro": [
				"SourceSerifPro-Black",
				"SourceSerifPro-Bold",
				"SourceSerifPro-Light",
				"SourceSerifPro-Regular",
				"SourceSerifPro-SemiBold",
			],
		};
		let values = [];
		const appKey = parseAppKey();

		let appId = null;
		if (!isEmpty(this.props.apps)) {
			appId = this.props.apps.find(app => app.key === appKey).id;
		}

		if (appId === "5c520a7a46b8bd4c607d957b") {
			values.push({ key: "Impact", value: "Impact", label: "Impact", group: "Custom App Fonts" });
		} else if (appId === "5c98f2f499d8e3051c59d681") {
			values.push({
				key: "Brown-Regular",
				value: "Brown-Regular",
				label: "Brown Regular",
				group: "Custom App Fonts",
			});
			values.push({
				key: "Brown-Regular-Italic",
				value: "Brown-Regular-Italic",
				label: "Brown Italic",
				group: "Custom App Fonts",
			});
			values.push({ key: "Brown-Bold", value: "Brown-Bold", label: "Brown Bold", group: "Custom App Fonts" });
			values.push({
				key: "Brown-Bold-Italic",
				value: "Brown-Bold-Italic",
				label: "Brown Bold Italic",
				group: "Custom App Fonts",
			});
		} else if (appId === "5cdb8a911a6e190a5847a6c7") {
			values.push({
				key: "WorkSans-Medium",
				value: "WorkSans-Medium",
				label: "Work Sans Medium",
				group: "Custom App Fonts",
			});
			values.push({
				key: "WorkSans-SemiBold",
				value: "WorkSans-SemiBold",
				label: "Work Sans Semi Bold",
				group: "Custom App Fonts",
			});
			values.push({
				key: "WorkSans-Bold",
				value: "WorkSans-Bold",
				label: "Work Sans Bold",
				group: "Custom App Fonts",
			});
		} else if (appId === "5d4a0b0a591f3a2090581168") {
			values.push({
				key: "Helvetica-Neue",
				value: "Helvetica-Neue",
				label: "Helvetica Neue",
				group: "Custom App Fonts",
			});
		} else if (appId === "5d443d606190704b54835a09") {
			values.push({
				key: "Gotham-Light",
				value: "Gotham-Light",
				label: "Gotham Light",
				group: "Custom App Fonts",
			});
			values.push({ key: "GothamBook", value: "GothamBook", label: "Gotham Book", group: "Custom App Fonts" });
			values.push({
				key: "Gotham-Medium",
				value: "Gotham-Medium",
				label: "Gotham Medium",
				group: "Custom App Fonts",
			});
			values.push({ key: "Gotham-Bold", value: "Gotham-Bold", label: "Gotham Bold", group: "Custom App Fonts" });
			values.push({
				key: "Gotham-Black",
				value: "Gotham-Black",
				label: "Gotham Black",
				group: "Custom App Fonts",
			});
		} else if (appId === "5d916659a0f6bf444471913f") {
			values.push({
				key: "Exo-Thin",
				value: "Exo-Thin",
				label: "Exo Thin",
				group: "Custom App Fonts",
			});
			values.push({
				key: "Exo-ThinItalic",
				value: "Exo-ThinItalic",
				label: "Exo Thin Italic",
				group: "Custom App Fonts",
			});
			values.push({
				key: "Exo-Regular",
				value: "Exo-Regular",
				label: "Exo Regular",
				group: "Custom App Fonts",
			});
			values.push({
				key: "Exo-RegularItalic",
				value: "Exo-RegularItalic",
				label: "Exo Regular Italic",
				group: "Custom App Fonts",
			});
			values.push({
				key: "Exo-Bold",
				value: "Exo-Bold",
				label: "Exo Bold",
				group: "Custom App Fonts",
			});
			values.push({
				key: "Exo-BoldItalic",
				value: "Exo-BoldItalic",
				label: "Exo Bold Italic",
				group: "Custom App Fonts",
			});
			values.push({
				key: "Exo-ExtraBold",
				value: "Exo-ExtraBold",
				label: "Exo ExtraBold",
				group: "Custom App Fonts",
			});
			values.push({
				key: "Exo-ExtraBoldItalic",
				value: "Exo-ExtraBoldItalic",
				label: "Exo Extra Bold Italic",
				group: "Custom App Fonts",
			});
		} else if (appId === "5db9de666aa4ca34181af689") {
			values.push(
				{
					key: "BergenMono-Regular",
					value: "BergenMono-Regular",
					label: "BergenMono Regular",
					group: "Custom App Fonts",
				},
				{
					key: "BergenMono-Bold",
					value: "BergenMono-Bold",
					label: "BergenMono Bold",
					group: "Custom App Fonts",
				},
				{
					key: "Obviously-NarrowBold",
					value: "Obviously-NarrowBold",
					label: "Obviously NarrowBold",
					group: "Custom App Fonts",
				},
				{
					key: "Quick-Marker",
					value: "Quick-Marker",
					label: "Quick Marker",
					group: "Custom App Fonts",
				},
				{
					key: "Biblio-Regular",
					value: "Biblio-Regular",
					label: "Biblio",
					group: "Custom App Fonts",
				},
				{
					key: "HighwayGothicExpanded",
					value: "HighwayGothicExpanded",
					label: "Highway Gothic",
					group: "Custom App Fonts",
				},
				{
					key: "Nickainley-Normal",
					value: "Nickainley-Normal",
					label: "Nickainley",
					group: "Custom App Fonts",
				},
				{
					key: "TTTrailers-Bold",
					value: "TTTrailers-Bold",
					label: "TTTrailers Bold",
					group: "Custom App Fonts",
				},
				{
					key: "VulfSans-Regular",
					value: "VulfSans-Regular",
					label: "VulfSans Regular",
					group: "Custom App Fonts",
				},
				{
					key: "VulfSans-Bold",
					value: "VulfSans-Bold",
					label: "VulfSans Bold",
					group: "Custom App Fonts",
				},
				{
					key: "VulfSans-Italic",
					value: "VulfSans-Italic",
					label: "VulfSans Italic",
					group: "Custom App Fonts",
				},
				{
					key: "VulfSans-Medium",
					value: "VulfSans-Medium",
					label: "VulfSans Medium",
					group: "Custom App Fonts",
				}
			);
		} else if (appId === "5ddc37022a67411bd0faa82c") {
			values.push({
				key: "BoxoutVariableGX",
				value: "BoxoutVariableGX",
				label: "BoxoutVariableGX",
				group: "Custom App Fonts",
			});
		} else if (appId === "6192ad7740728a09844056c7") {
			values.push(
				{
					key: "IntegralCF-DemiBold",
					value: "IntegralCF-DemiBold",
					label: "IntegralCF DemiBold",
					group: "Custom App Fonts",
				},
				{
					key: "IntegralCF-Heavy",
					value: "IntegralCF-Heavy",
					label: "IntegralCF Heavy",
					group: "Custom App Fonts",
				},
				{
					key: "ConstructioGrotesk-Regular",
					value: "ConstructioGrotesk-Regular",
					label: "ConstructioGrotesk Regular",
					group: "Custom App Fonts",
				},
				{
					key: "ProximaNova-Regular",
					value: "ProximaNova-Regular",
					label: "ProximaNova Regular",
					group: "Custom App Fonts",
				},
				{
					key: "ProximaNova-Black",
					value: "ProximaNova-Black",
					label: "ProximaNova Black",
					group: "Custom App Fonts",
				}
			);
		} else if (appId === "62753d9aafb8251ca8321aef") {
			values.push(
				{
					key: "BrandonText-Bold",
					value: "BrandonText-Bold",
					label: "Brandon Text Bold",
					group: "Custom App Fonts",
				},
				{
					key: "BrandonText-Light",
					value: "BrandonText-Light",
					label: "Brandon Text Light",
					group: "Custom App Fonts",
				},
				{
					key: "BrandonText-Regular",
					value: "BrandonText-Regular",
					label: "Brandon Text Regular",
					group: "Custom App Fonts",
				}
			);
		} else if (appId === "5eeb95ece3400d19c4411a97") {
			values.push({
				key: "Bizantheum",
				value: "Bizantheum",
				label: "Bizantheum Regular",
				group: "Custom App Fonts",
			});
		} else if (appId === "5d6fd40228a5d112eccde151") {
			values.push(
				{
					key: "DukeCharming-Regular",
					value: "DukeCharming-Regular",
					label: "Duke Charming Regular",
					group: "Custom App Fonts",
				},
				{
					key: "EmfatickNF",
					value: "EmfatickNF",
					label: "Emfatick NF",
					group: "Custom App Fonts",
				},
				{
					key: "MasterWorks",
					value: "MasterWorks",
					label: "Master Works",
					group: "Custom App Fonts",
				}
			);
		} else if (appId === "629fc781b51230140479803e") {
			values.push(
				{
					key: "Gotham-Bold",
					value: "Gotham-Bold",
					label: "Gotham Bold",
					group: "Custom App Fonts",
				},
				{
					key: "Gotham-Light",
					value: "Gotham-Light",
					label: "Gotham Light",
					group: "Custom App Fonts",
				},
				{
					key: "Gotham-Black",
					value: "Gotham-Black",
					label: "Gotham Black",
					group: "Custom App Fonts",
				},
				{
					key: "Gotham-Medium",
					value: "Gotham-Medium",
					label: "Gotham Medium",
					group: "Custom App Fonts",
				},
				{
					key: "DINCond-Regular",
					value: "DINCond-Regular",
					label: "DINCond Regular",
					group: "Custom App Fonts",
				},
				{
					key: "DINCond-Bold",
					value: "DINCond-Bold",
					label: "DINCond Bold",
					group: "Custom App Fonts",
				},
				{
					key: "DINCond-Light",
					value: "DINCond-Light",
					label: "DINCond Light",
					group: "Custom App Fonts",
				},
				{
					key: "DINCond-Black",
					value: "DINCond-Black",
					label: "DINCond Black",
					group: "Custom App Fonts",
				}
			);
		} else if (appId === "6446a62df409100cc4dfa619") {
			values.push(
				{
					key: "TAN-NIMBUS",
					value: "TAN-NIMBUS",
					label: "TAN NIMBUS Regular",
					group: "Custom App Fonts",
				},
				{
					key: "JimmyScript-Regular",
					value: "JimmyScript-Regular",
					label: "JimmyScript Regular",
					group: "Custom App Fonts",
				}
			);
		} else if (appId === "5da4c96c0589471330dc2161") {
			values.push(
				{
					key: "Inter18pt-Thin",
					value: "Inter18pt-Thin",
					label: "Inter Thin",
					group: "Custom App Fonts",
				},
				{
					key: "Inter18pt-Regular",
					value: "Inter18pt-Regular",
					label: "Inter Regular",
					group: "Custom App Fonts",
				},
				{
					key: "MonaSans-Medium",
					value: "MonaSans-Medium",
					label: "Mona Medium",
					group: "Custom App Fonts",
				},
				{
					key: "MonaSans-Black",
					value: "MonaSans-Black",
					label: "Mona Black",
					group: "Custom App Fonts",
				}
			);
		}
		Object.keys(fonts).forEach(font => {
			fonts[font].forEach(fontName => {
				values.push({
					key: fontName,
					value: fontName,
					label: fontName.replace("-", " "),
					group: font.replace("-", " "),
				});
			});
		});
		this.state = {
			values,
		};
	}

	render() {
		return (
			<div className="picker-input">
				{this.state.values && <SelectInput {...this.props} values={this.state.values} />}
			</div>
		);
	}
}

FontPicker.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	placeholder: PropTypes.string,
	tagInstructions: PropTypes.string,
	apps: PropTypes.array,
	isRequired: PropTypes.bool,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
});

const mapDispatchToProps = () => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FontPicker);
